import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover a unidade <b>${this.currentEntity.unit.number}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/unit/resources/computed.js